<template>
  <p :class="{fz:nameCount=='applying'&&$i18n.locale ==='km'}">
  <i :class="[icon,'sub-el-icon']" />
  <span slot="title">{{title}}{{ hasTotal()}}</span>
  <el-badge v-if="orderCount&&nameCount&&orderCount[nameCount]>0" :value="orderCount[nameCount]" class="item" />
  </p>
</template>
<script>
export default {
  name: 'MenuItem',
  // functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    orderCount: {
      type: Object,
      default: () => {
      }
    },
    nameCount: {
      type: String,
      default: ''
    }
  },
  methods: {
    hasTotal() {
      switch (this.nameCount) {
        case 'booking':
          return `(${this.orderCount?.bookingTotal || 0})`
          break;
        case 'prepareds':
          return `(${this.orderCount?.prepared || 0})`
          break;
        case 'preparings':
          return `(${this.orderCount?.preparing || 0})`
          break;
        default:
          return ''
      }
    }
  }
  // render(h, context) {
  //   const {icon, title, orderCount, nameCount} = context.props
  //   const vnodes = []
  //
  //   if (icon) {
  //     if (icon.includes('el-icon')) {
  //       vnodes.push(<i class={[icon, 'sub-el-icon']}/>)
  //     }
  //   }
  //   if (title) {
  //     if (orderCount && nameCount) {
  //       const res = orderCount[nameCount]
  //       const result = h('el-badge', {
  //         attrs: {
  //           value: res
  //         },
  //         'class': {
  //           item: true
  //         }
  //       })
  //       vnodes.push(<span slot='title'>{(title)}{result}</span>
  //       )
  //     } else {
  //       vnodes.push(<span slot='title'>{(title)}</span>)
  //     }
  //   }
  //   return vnodes
  // },
}
</script>

<style lang="stylus" scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
.fz{
  font-size 12px
  margin-left -25px
}
.item {
  margin-top -7px;
  margin-left 15px
  font-size 14px
}
</style>
